import React from "react";
import { ArrowRight, Shield, Award, Clock, Users } from "lucide-react";
import { Button } from "./ui/button";
import { companyInfo, heroStats } from "../mock";

export const Hero = () => {
  return (
    <section id='home' className='relative py-12 lg:py-32 overflow-hidden'>
      {/* Background Image with Overlay */}
      <div
        className='absolute inset-0 bg-cover bg-center bg-no-repeat'
        style={{
          backgroundImage: `url(${companyInfo.heroBackground})`,
          backgroundColor: "rgba(0,0,0,0.5)", // overlay color
          backgroundBlendMode: "darken", // or "multiply", "overlay"
        }}>
        <div className='absolute inset-0 bg-slate-900/80'></div>
      </div>

      {/* Content */}
      <div className='container mx-auto px-4 relative z-10'>
        <div className='grid lg:grid-cols-2 gap-8 lg:gap-12 items-center'>
          {/* Content */}
          <div className='space-y-6 lg:space-y-8 text-center lg:text-left'>
            <div className='space-y-4'>
              <h1 className='text-3xl md:text-4xl lg:text-6xl font-bold text-white leading-tight'>
                Premium
                <span className='text-orange-400 block'>Metal Solutions</span>
                for Modern Industry
              </h1>
              <p className='text-lg lg:text-xl text-slate-200 leading-relaxed'>
                {companyInfo.description} Trusted by industries across India for
                exceptional quality, technical expertise, and reliable supply
                chain solutions.
              </p>
            </div>

            {/* Key Features */}
            <div className='flex flex-wrap gap-3 lg:gap-6 justify-center lg:justify-start'>
              <div className='flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 lg:px-4 py-2 rounded-full border border-white/20 text-sm lg:text-base'>
                <Shield className='h-4 w-4 lg:h-5 lg:w-5 text-green-400' />
                <span className='font-medium text-slate-200'>
                  ISO 9001:2015 Certified
                </span>
              </div>
              <div className='flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 lg:px-4 py-2 rounded-full border border-white/20 text-sm lg:text-base'>
                <Award className='h-4 w-4 lg:h-5 lg:w-5 text-blue-400' />
                <span className='font-medium text-slate-200'>
                  Premium Quality
                </span>
              </div>
              <div className='flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-3 lg:px-4 py-2 rounded-full border border-white/20 text-sm lg:text-base'>
                <Clock className='h-4 w-4 lg:h-5 lg:w-5 text-orange-400' />
                <span className='font-medium text-slate-200'>
                  Quick Delivery
                </span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className='flex flex-col sm:flex-row gap-4 justify-center lg:justify-start'>
              <Button
                size='lg'
                className='bg-[#022d47] hover:bg-[#033858] text-white px-6 lg:px-8 py-3 lg:py-4 text-base lg:text-lg group border-0'
                onClick={() =>
                  document
                    .getElementById("products")
                    .scrollIntoView({ behavior: "smooth" })
                }>
                Explore Products
                <ArrowRight className='ml-2 h-4 w-4 lg:h-5 lg:w-5 group-hover:translate-x-1 transition-transform' />
              </Button>
              <Button
                size='lg'
                variant='outline'
                className='border-2 border-white/30 text-white hover:bg-white/10 hover:border-white/50 px-6 lg:px-8 py-3 lg:py-4 text-base lg:text-lg backdrop-blur-sm'
                onClick={() => window.open(`mailto:${companyInfo.email}`)}>
                Get Quote
              </Button>
            </div>
          </div>

          {/* Stats Grid */}
          <div className='grid grid-cols-2 gap-4 lg:gap-6 mt-8 lg:mt-0'>
            {heroStats.map((stat, index) => (
              <div
                key={index}
                className='bg-white/10 backdrop-blur-md p-4 lg:p-8 rounded-xl border border-white/20 text-center hover:bg-white/15 transition-all duration-300'>
                <div className='text-2xl lg:text-3xl xl:text-4xl font-bold text-orange-400 mb-2'>
                  {stat.number}
                </div>
                <div className='text-slate-200 font-medium text-sm lg:text-base'>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className='absolute top-20 left-10 w-20 h-20 bg-orange-400/20 rounded-full opacity-50'></div>
      <div className='absolute bottom-20 right-10 w-16 h-16 bg-blue-400/20 rounded-full opacity-50'></div>
    </section>
  );
};
